import { useSceneEntities } from "@/stores/SceneEntities";
export function useAssetTub2852Door(payload, viewport) {
  const sceneEntities = useSceneEntities();  

  viewport.invalidateTransformForKey("elite_2852_tub_door","elite_2852_tub_door_open");
}
